import axios from 'axios'

const getCategories = async () =>
  axios.get(`${process.env.REACT_APP_URI}/categories`)

export { getCategories }
